<div *ngIf="totalStats" class="row g-1 mb-4">
    <div class="card mt-2">
        <div class="card-header bg-primary d-flex justify-content-between align-items-center border-bottom-0">
            <h6 class="card-title mb-0 text-light">Estadisticos</h6>
        </div>
        <div class="card p-3">

            <div class="row">
                <div class="col-md-6">
                    <div class="card border-0 mb-3">
                        <div class="card-body">

                            <ul class="list-unstyled mt-3 mb-0">
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.porcVentasFacturas.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.porcVentasFacturas.value | number:'1.0-2' }}</span>
                                </li>
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.porcVentasBoletas.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.porcVentasBoletas.value | number:'1.0-2' }}</span>
                                </li>
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.ventasPromedio.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.ventasPromedio.value | number:'1.0-0' }}</span>
                                </li>
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.nClientes.name  }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.nClientes.value | number:'1.0-0' }}</span>
                                </li>
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.compraPromedio.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.compraPromedio.value | number:'1.0-0' }}</span>
                                </li>
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.nProveedores.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.nProveedores.value | number:'1.0-0' }}</span>
                                </li>
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.margen.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.margen.value | number:'1.0-0' }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div class="col-md-6">
                    <div class="card border-0 mb-3">
                        <div class="card-body">

                            <ul class="list-unstyled mt-3 mb-0">
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.margenPromedio.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.margenPromedio.value | number:'1.0-0' }}</span>
                                </li>
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.porcVentasNC.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.porcVentasNC.value | number:'1.0-2' }}</span>
                                </li>
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.ventaUltimoMes.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.ventaUltimoMes.value | number:'1.0-0' }}</span>
                                </li>
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.ventaAnioActual.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.ventaAnioActual.value | number:'1.0-0' }}</span>
                                </li>
                                <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">{{ totalStats.porcCrecVentasUltimoMes.name }}</a>
                                    <span class="badge bg-primary rounded">
                                        {{ totalStats.porcCrecVentasUltimoMes.value | number:'1.0-0' }}</span>
                                </li>
                                <!-- <li class="d-flex justify-content-between align-items-center py-1 mt-2">
                                    <a href="#" class="color-600">% Crecimiento Ventas ultimo Mes</a>
                                    <span class="badge bg-primary rounded">% {{
                                        valoresCalculados?.porcentajeCrecimientoVentasUltimoMes }}</span>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
